export default function ImpressumPage() {
  return (
    <main className="container max-w-3xl py-16">
      <h1 className="font-display text-4xl font-bold tracking-tight text-foreground">Impressum</h1>

      <section className="mt-10 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">Angaben gemäß § 5 DDG</h2>
        <p className="text-muted-foreground leading-relaxed">
          David Federl
          <br />
          Torflash
          <br />
          Breslauer Straße 22
          <br />
          82140 Olching
          <br />
          Deutschland
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">Kontakt</h2>
        <p className="text-muted-foreground leading-relaxed">
          Telefon:{" "}
          <a href="tel:+49176281646701" className="text-primary hover:underline">
            +49 176 281646701
          </a>
          <br />
          E-Mail:{" "}
          <a href="mailto:info@torflash.de" className="text-primary hover:underline">
            info@torflash.de
          </a>
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">Umsatzsteuer</h2>
        <p className="text-muted-foreground leading-relaxed">
          Gemäß § 19 UStG (Kleinunternehmerregelung) wird keine Umsatzsteuer berechnet und daher in Rechnungen nicht
          ausgewiesen.
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">
          Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
        </h2>
        <p className="text-muted-foreground leading-relaxed">
          David Federl, Breslauer Straße 22, 82140 Olching
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">EU-Streitschlichtung</h2>
        <p className="text-muted-foreground leading-relaxed">
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            ec.europa.eu/consumers/odr
          </a>
          . Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>

      <section className="mt-8 space-y-4">
        <h2 className="font-display text-xl font-bold text-foreground">Haftungsausschluss</h2>

        <div className="space-y-2">
          <h3 className="font-semibold text-foreground">Haftung für Inhalte</h3>
          <p className="text-muted-foreground leading-relaxed">
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und
            Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7
            Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis
            10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
            Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
        </div>

        <div className="space-y-2">
          <h3 className="font-semibold text-foreground">Haftung für Links</h3>
          <p className="text-muted-foreground leading-relaxed">
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
            Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Eine permanente
            inhaltliche Kontrolle der verlinkten Seiten ist ohne konkrete Anhaltspunkte einer Rechtsverletzung jedoch
            nicht zumutbar.
          </p>
        </div>

        <div className="space-y-2">
          <h3 className="font-semibold text-foreground">Urheberrecht</h3>
          <p className="text-muted-foreground leading-relaxed">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          </p>
        </div>

        <p className="text-xs text-muted-foreground italic">
          Hinweis: Torflash ist ein unabhängiges Angebot und steht in keiner offiziellen Verbindung zum Bayerischen
          Fußball-Verband (BFV).
        </p>
      </section>
    </main>
  );
}
